import {Component, Input} from '@angular/core';
import {FormArray} from '@angular/forms';
import {DynamicFields} from '@namespaces/dynamic-fields.namespace';
import {DynamicFieldsHelperService} from '../../dynamic-fields-helper.service';

@Component({
    selector: 'app-dynamic-fields-group',
    templateUrl: 'dynamic-fields-group.component.html'
})

export class DynamicFieldsGroupComponent {
    @Input() fbArray: FormArray = new FormArray([]);

    @Input() useSmallFields = false;

    public fields: DynamicFields.ParamWithForm[] = [];

    public typesEnum = DynamicFields.FieldType;

    restoreFields(fields: DynamicFields.Field[] = []) {
        const formValue: DynamicFields.FieldFormValue[] = this.fbArray.value;
        this.fields = DynamicFieldsHelperService.createParamsWithForm(fields, formValue);
        this.makeFormArray();
    }

    /**
     * Установить структуру поля
     */
    setGroupStructure(fields: DynamicFields.Field[] = []) {
        this.fields = DynamicFieldsHelperService.createParamsWithForm(fields, []);
        this.makeFormArray();
    }

    private makeFormArray() {
        DynamicFieldsHelperService.setFormArrayWithParams(this.fbArray, this.fields);
    }
}
